export default __webpack_public_path__ + "static/media/dentist-tooth-care-512.4b82cb12.png";